// Author: Aynur Guliyeva
const stepButtons = document.querySelectorAll('.step-button');
const progress = document.querySelector('#progress');

Array.from(stepButtons).forEach((button, index) => {
    button.addEventListener('click', () => {
        progress.setAttribute('value', (index * 100) / (stepButtons.length - 1));

        stepButtons.forEach((item, secindex) => {
            if (index > secindex) {
                item.classList.add('done');
            }
            if (index < secindex) {
                item.classList.remove('done');
            }
        });
    });
});
let up = 0;
let up2 = 0;
let up3 = 9000;
const target = [1849, 768, 12109];
const targetElement = document.querySelector('.donBox');
let triggered = false;

function updated() {
    if (!triggered && isElementInViewport(targetElement)) {
        triggered = true;
        const count = document.getElementById('counter');
        const count2 = document.getElementById('counter2');
        const count3 = document.getElementById('counter3');

        const counts = setInterval(() => {
            if (up < target[0]) {
                count.innerHTML = ++up;
            }

            if (up2 < target[1]) {
                count2.innerHTML = ++up2;
            }

            if (up3 < target[2]) {
                count3.innerHTML = ++up3;
            }

            if (up === target[0] && up2 === target[1] && up3 === target[2]) {
                clearInterval(counts);
            }
        }, 10);
    }
}

function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

window.addEventListener('scroll', updated);
